 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3e7cf6942113443944dbdaa9f8e837b45bef80ef","1":"b01f64f3","2":"100c9062","3":"b637e9a5","4":"eebddd20647615da2f58f9d9bd7beede17d9eaec","5":"a09686f1","6":"aff08ac6e5e1e0ac820df96ef459297dcf9ea5ce","7":"b07aaa4f","8":"41d5e1196ef8844c7e925e7876758d8a32c8c537","9":"18f07bd5d763d7308b1ea6d59dff6a494d74ad4b","10":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","11":"e8cbb670aba452384e47764d95ca5be58beb1144","12":"888c22908c6a1b8476a48b8f624821ab43919eb0","13":"component---src-pages-points-checkout-index-js","14":"component---src-pages-rewards-link-index-js","15":"component---src-pages-wallet-checkout-index-js","17":"e52b9ad6","23":"component---src-pages-about-au-js","24":"component---src-pages-about-index-js","25":"component---src-pages-about-nz-js","26":"component---src-pages-checkout-js","27":"component---src-pages-embed-shopify-dashboard-js","28":"component---src-pages-error-js","29":"component---src-pages-index-js","30":"component---src-pages-info-js","31":"component---src-pages-merchant-analytics-index-js","32":"component---src-pages-merchant-home-index-js","33":"component---src-pages-merchant-index-js","34":"component---src-pages-merchant-login-callback-js","35":"component---src-pages-merchant-login-index-js","36":"component---src-pages-merchant-logout-js","37":"component---src-pages-merchant-orders-create-js","38":"component---src-pages-merchant-orders-dashboard-js","39":"component---src-pages-merchant-orders-review-js","40":"component---src-pages-merchant-orders-summary-js","41":"component---src-pages-merchant-pos-initiate-js","42":"component---src-pages-merchant-pos-orders-summary-js","43":"component---src-pages-merchant-reports-index-js","44":"component---src-pages-merchant-trainingguides-index-js","45":"component---src-pages-outcome-js","46":"component---src-pages-payment-complete-js","47":"component---src-pages-playground-checkout-js","48":"component---src-pages-playground-widget-js","49":"component---src-pages-playground-widget-testing-js","50":"component---src-pages-points-index-js","51":"component---src-pages-points-login-callback-js","52":"component---src-pages-points-login-index-js","53":"component---src-pages-purchase-initiate-js","54":"component---src-pages-rewards-index-js","55":"component---src-pages-rewards-login-callback-js","56":"component---src-pages-rewards-login-index-js","57":"component---src-pages-shopify-about-js","58":"component---src-pages-shopify-auth-js","59":"component---src-pages-shopify-install-js","60":"component---src-pages-shopify-payment-index-js","61":"component---src-pages-shopify-payment-outcome-js","62":"component---src-pages-shopify-payment-settings-js","63":"component---src-pages-wallet-index-js","64":"component---src-pages-wallet-login-callback-js","65":"component---src-pages-wallet-login-index-js","66":"component---src-pages-wallet-logout-js"}[chunkId]||chunkId) + "-" + {"0":"7316e5dc2087abf363f9","1":"b13fa9b40f46e65c4196","2":"6819fae91e57ea8735a6","3":"b34c2c214f60f1bcd649","4":"f46c31df29c0eca0ace8","5":"23de99ba6c4874762fb0","6":"770c8f409fb06ef69bd6","7":"69899a3f1ba058e1303a","8":"47a1094dbeb5e617663d","9":"b04fd03a9bfc76735e70","10":"89dd0f8292797d344fe3","11":"b22a8c8128e80b733a1f","12":"d29e59b967dfa51d6562","13":"95f724d01c41df7a8638","14":"2dde784ea49e2d707576","15":"c89b804dc22bfbfc22f5","17":"8004bc68451ecc117e36","23":"5c9dd38353d22ec82b66","24":"aec700baa960aaab95db","25":"b4cb9d13c86bb651d5f2","26":"a7b172df393d7ae36acb","27":"85a2fab9c832ba552801","28":"fe0b9870c1f8a97fbb72","29":"825539026494b1d0c1c8","30":"53fe55a491d8c2b55843","31":"b1e7d394c97500d7b442","32":"5a7c950a6d876139c9de","33":"a97ebfbd65fc91040997","34":"f77df55d30024d155f89","35":"07f22da5624dc6d8a79a","36":"e7b080f485569930d705","37":"e08fd4a9dd95ccc7183d","38":"33b0ad56b36ce5583296","39":"73aba12ba72d2770e3fe","40":"13253a9a0b25a55d8af8","41":"8855d01cc61da1068fe0","42":"cceb50ff02700b507941","43":"8246ce21df1758a49720","44":"df024a6f7add30151279","45":"08625aefb35b27863380","46":"98a557ad0d7f7e212a6d","47":"3b4bb9d2cbbe7e53801f","48":"aedc50212c1dc29d1b24","49":"217b828fac93647868ee","50":"bf6a93ef210e729b97a6","51":"16e0638ad380bc86b12c","52":"dd3b2dc4949cdfc7ca65","53":"b818e8ddab0de5a652d3","54":"afe4bafe6d892c0f3eb3","55":"2bf32f222a9008671fa5","56":"07b095061532b778d638","57":"b8c21072243025c5a99a","58":"c777800a7bb222c20874","59":"31ebf04e5c74048945f0","60":"c7cbe119fa631f23a648","61":"789dce44d2f516688bb1","62":"70e266f16b2034a134a1","63":"07278a6a1c20ffee96bf","64":"6eff6b8c896a4eedd73d","65":"c9ef76f306426a3f61ff","66":"c714d1c962a8d56d2d3b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
